import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chess-association-ngp-celebrates-international-chess-day',
  templateUrl: './chess-association-ngp-celebrates-international-chess-day.component.html',
  styleUrls: ['./chess-association-ngp-celebrates-international-chess-day.component.scss']
})
export class ChessAssociationNgpCelebratesInternationalChessDayComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
